<template>
  <div>
    Olá!
  </div>
</template>

<script>
  export default {
  }
</script>